"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MATCH_URL = void 0; // regex to match URL, from http://urlregex.com/

var MATCH_URL = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
exports.MATCH_URL = MATCH_URL;
var _default = {
  MATCH_URL: MATCH_URL
};
exports.default = _default;